// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"354":"project","530":"page","597":"projects","757":"not-found","841":"studio","946":"news","962":"home"}[chunkId] + "." + {"354":"ceb66ba0","530":"2996c9f3","597":"be5b82d4","757":"d9094f40","841":"ef671068","946":"10f6d751","962":"0960a827"}[chunkId] + ".css";
};